import { render, staticRenderFns } from "./UploadSpecimenVideo.vue?vue&type=template&id=a194de82&scoped=true"
import script from "./UploadSpecimenVideo.vue?vue&type=script&lang=js"
export * from "./UploadSpecimenVideo.vue?vue&type=script&lang=js"
import style0 from "./UploadSpecimenVideo.vue?vue&type=style&index=0&id=a194de82&prod&lang=scss&scoped=true"
import style1 from "./UploadSpecimenVideo.vue?vue&type=style&index=1&id=a194de82&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a194de82",
  null
  
)

export default component.exports